import { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { NavContext } from "@/context/NavContext";
import { useAuthContext } from "@/context/AuthContext";
import { logout } from "@/firebase/auth";
import Link from "next/link";

const wizardItems = [
  {
    name: "Builder",
    svg: (
      <svg
        width="18"
        height="21"
        viewBox="0 0 18 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.9062 14.0311L8.99996 18.6417L1.09372 14.0311C0.937175 13.9532 0.756818 13.9378 0.589353 13.9882C0.421888 14.0385 0.279901 14.1508 0.192294 14.3021C0.104686 14.4535 0.0780422 14.6325 0.117784 14.8028C0.157527 14.9731 0.260668 15.1219 0.406216 15.2188L8.65621 20.0313C8.76134 20.0926 8.88085 20.1249 9.00254 20.1249C9.12424 20.1249 9.24375 20.0926 9.34887 20.0313L17.5989 15.2188C17.6781 15.174 17.7477 15.1138 17.8035 15.0419C17.8593 14.97 17.9003 14.8877 17.924 14.7998C17.9478 14.7119 17.9538 14.6202 17.9418 14.5299C17.9299 14.4397 17.9001 14.3527 17.8542 14.2741C17.8083 14.1954 17.7473 14.1267 17.6747 14.0718C17.602 14.0169 17.5192 13.977 17.431 13.9544C17.3428 13.9318 17.251 13.927 17.1609 13.9401C17.0708 13.9533 16.9843 13.9842 16.9062 14.0311Z" />
        <path d="M16.9062 9.90613L8.99996 14.5167L1.09372 9.90613C0.937175 9.82819 0.756818 9.81284 0.589353 9.86318C0.421888 9.91353 0.279901 10.0258 0.192294 10.1771C0.104686 10.3285 0.0780422 10.5075 0.117784 10.6778C0.157527 10.8481 0.260668 10.9969 0.406216 11.0938L8.65621 15.9063C8.76134 15.9676 8.88085 15.9999 9.00254 15.9999C9.12424 15.9999 9.24375 15.9676 9.34887 15.9063L17.5989 11.0938C17.6781 11.049 17.7477 10.9888 17.8035 10.9169C17.8593 10.845 17.9003 10.7627 17.924 10.6748C17.9478 10.5869 17.9538 10.4952 17.9418 10.4049C17.9299 10.3147 17.9001 10.2277 17.8542 10.1491C17.8083 10.0704 17.7473 10.0017 17.6747 9.9468C17.602 9.89193 17.5192 9.85204 17.431 9.82944C17.3428 9.80684 17.251 9.80198 17.1609 9.81515C17.0708 9.82831 16.9843 9.85924 16.9062 9.90613Z" />
        <path d="M0.40624 6.96882L8.65624 11.7813C8.76136 11.8426 8.88088 11.8749 9.00257 11.8749C9.12426 11.8749 9.24377 11.8426 9.3489 11.7813L17.5989 6.96882C17.7027 6.90827 17.7888 6.82158 17.8486 6.71739C17.9085 6.6132 17.94 6.49515 17.94 6.37499C17.94 6.25484 17.9085 6.13679 17.8486 6.03259C17.7888 5.9284 17.7027 5.84171 17.5989 5.78116L9.3489 0.968665C9.24377 0.907362 9.12426 0.875061 9.00257 0.875061C8.88088 0.875061 8.76136 0.907362 8.65624 0.968665L0.40624 5.78116C0.302458 5.84171 0.216356 5.9284 0.156515 6.03259C0.0966749 6.13679 0.0651855 6.25484 0.0651855 6.37499C0.0651855 6.49515 0.0966749 6.6132 0.156515 6.71739C0.216356 6.82158 0.302458 6.90827 0.40624 6.96882Z" />
      </svg>
    ),
    path: "/builder",
    base: "/builder",
  },
];

const agentNavItems = [
  {
    name: "My Dashboard",
    svg: (
      <svg
        width="24"
        height="21"
        viewBox="0 0 24 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.9999 3.63833L17.8333 8.88833V18H15.4999V11H8.49992V18H6.16659V8.88833L11.9999 3.63833ZM11.9999 0.5L0.333252 11H3.83325V20.3333H10.8333V13.3333H13.1666V20.3333H20.1666V11H23.6666L11.9999 0.5Z" />
      </svg>
    ),
    path: "/",
    // base: "/",
  },
];

const supervisorNavItems = [
  {
    name: "My Dashboard",
    svg: (
      <svg
        width="24"
        height="21"
        viewBox="0 0 24 21"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.9999 3.63833L17.8333 8.88833V18H15.4999V11H8.49992V18H6.16659V8.88833L11.9999 3.63833ZM11.9999 0.5L0.333252 11H3.83325V20.3333H10.8333V13.3333H13.1666V20.3333H20.1666V11H23.6666L11.9999 0.5Z" />
      </svg>
    ),
    path: "/",
    // base: "/",
  },
  {
    name: "Reports",
    svg: (
      <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.25 19.75H5.68333C4.65657 19.75 4.14319 19.75 3.75102 19.5502C3.40605 19.3744 3.12559 19.0939 2.94982 18.749C2.75 18.3568 2.75 17.8434 2.75 16.8167V3.25M6.41667 10.125V16.5417M10.5417 5.54167V16.5417M14.6667 10.125V16.5417M18.7917 5.54167V16.5417"
          // stroke="#FDFDFD"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/reports",
    base: "/reports",
  },
  // {
  //   name: "FS Dashboard",
  //   svg: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="23"
  //       fill="none"
  //     >
  //       <path
  //         fill="#667085"
  //         d="M18.906 15.031 11 19.641l-7.906-4.61a.687.687 0 0 0-.688 1.188l8.25 4.812a.687.687 0 0 0 .693 0l8.25-4.812a.685.685 0 0 0 .255-.945.687.687 0 0 0-.948-.243Z"
  //       />
  //       <path
  //         fill="#667085"
  //         d="M18.906 10.906 11 15.516l-7.906-4.61a.687.687 0 0 0-.688 1.188l8.25 4.812a.687.687 0 0 0 .693 0l8.25-4.812a.685.685 0 0 0 .255-.945.689.689 0 0 0-.948-.243Z"
  //       />
  //       <path
  //         fill="#667085"
  //         d="m2.406 7.969 8.25 4.812a.688.688 0 0 0 .693 0l8.25-4.812a.687.687 0 0 0 0-1.188l-8.25-4.812a.687.687 0 0 0-.693 0L2.406 6.78a.688.688 0 0 0 0 1.188Z"
  //       />
  //     </svg>
  //   ),
  //   path: "/fs",
  //   base: "/fs",
  // },
  {
    name: "Agents",
    svg: (
      <svg
        width="22"
        height="22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.167 19.25v-1.833a3.668 3.668 0 0 0-2.75-3.552M14.208 3.018a3.668 3.668 0 0 1 0 6.8m1.375 9.433c0-1.709 0-2.563-.279-3.236a3.667 3.667 0 0 0-1.984-1.985c-.674-.279-1.528-.279-3.237-.279h-2.75c-1.708 0-2.562 0-3.236.28a3.667 3.667 0 0 0-1.985 1.984c-.279.673-.279 1.527-.279 3.236M12.375 6.417a3.667 3.667 0 1 1-7.333 0 3.667 3.667 0 0 1 7.333 0Z"
          // stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/agents",
    base: "/agents",
  },
];

const NavBar = ({ children }) => {
  const { user } = useAuthContext();

  const router = useRouter();

  const [navItems, setNavItems] = useState(agentNavItems);
  const { hide, setHide } = useContext(NavContext);

  const toggleHide = () => setHide(!hide);

  useEffect(() => {
    let tempNavItems = [];
    const department = user?.role.split("-");

    let isManager = false;

    if (department?.length > 1) {
      const [prefix, role] = department;
      if (role === "manager") isManager = true;
    } else if (user?.role === "manager" || user?.role === "supervisor")
      isManager = true;

    if (isManager) tempNavItems = supervisorNavItems;
    else if (user?.role === "wizard")
      tempNavItems = [...supervisorNavItems, ...wizardItems];
    else tempNavItems = agentNavItems;

    if (
      user?.role?.includes("qc") &&
      !tempNavItems.find((item) => item.name === "QC Dashboard")
    )
      tempNavItems.push({
        name: "QC Dashboard",
        svg: (
          <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M11.9999 3.63833L17.8333 8.88833V18H15.4999V11H8.49992V18H6.16659V8.88833L11.9999 3.63833ZM11.9999 0.5L0.333252 11H3.83325V20.3333H10.8333V13.3333H13.1666V20.3333H20.1666V11H23.6666L11.9999 0.5Z" />
          </svg>
        ),
        path: "/qc",
      });

    setNavItems(tempNavItems);
  }, [user]);

  return (
    <div
      className={`h-full bg-white transition-all ${
        hide ? "w-[90px] min-w-[90px]" : "w-[270px] min-w-[270px]"
      }`}
    >
      <div className={`relative w-full pb-4`}>
        <p className="py-4 w-full text-center text-3xl font-bold text-dark-blue">
          {hide ? "C" : "Cybersoft"}
        </p>

        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`absolute right-2 bottom-1 cursor-pointer transition-all duration-300 ${
            hide ? "rotate-0" : "-rotate-180"
          }`}
          onClick={toggleHide}
        >
          <path
            d="M6.5 17L11.5 12L6.5 7M13.5 17L18.5 12L13.5 7"
            stroke="#0F2844"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <div className="w-full h-[1.5px] bg-[#F3F3F3]" />

      {children ?? (
        <>
          {/* NAV LIST */}
          <div className="p-3 flex flex-col gap-1 w-full">
            {navItems.map((item) => (
              <Link
                key={item.name}
                href={item.disabled ? "#" : item.path}
                className={`flex gap-3 px-3 py-2 rounded-md font-medium text-base transition-all truncate ${
                  item.disabled
                    ? "bg-transparent text-gray-500 stroke-gray-500 fill-gray-500 opacity-50 cursor-not-allowed"
                    : (
                        item.base
                          ? router.asPath.includes(item.base)
                          : router.asPath === item.path
                      )
                    ? "bg-dark-blue text-white stroke-white fill-white cursor-pointer"
                    : "bg-transparent text-gray-500 stroke-gray-500 fill-gray-500 hover:bg-[#F3F3F3] hover:text-black hover:stroke-black hover:fill-black cursor-pointer"
                }`}
              >
                <div className={hide ? "mx-auto" : ""}>{item.svg}</div>

                {!hide && <p className="truncate">{item.name}</p>}
              </Link>
            ))}
          </div>

          <div className="w-full h-[1.5px] bg-[#F3F3F3]" />

          {/* ACCOUNT */}
          <div className="py-3 px-6 flex flex-col gap-3 w-full">
            <div className="flex gap-3 items-center">
              {/* AVATAR */}
              <div className="rounded-full w-10 h-10 bg-slate-200" />

              {/* NAME */}
              {!hide && (
                <p className="text-gray-700 font-semibold text-base">
                  {user?.first_name} {user?.last_name}
                </p>
              )}
            </div>

            <div
              className="flex gap-3 items-center text-gray-500 stroke-gray-500 hover:text-black hover:stroke-black cursor-pointer transition-all"
              onClick={() => {
                logout().then(() => router.push("/auth/login"));
              }}
            >
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                xmlns="http://www.w3.org/2000/svg"
                className={hide ? "mx-auto" : ""}
                fill="none"
              >
                <path
                  d="M13.3333 14.6667L17.5 10.5M17.5 10.5L13.3333 6.33333M17.5 10.5H7.5M7.5 3H6.5C5.09987 3 4.3998 3 3.86502 3.27248C3.39462 3.51217 3.01217 3.89462 2.77248 4.36502C2.5 4.8998 2.5 5.59987 2.5 7V14C2.5 15.4001 2.5 16.1002 2.77248 16.635C3.01217 17.1054 3.39462 17.4878 3.86502 17.7275C4.3998 18 5.09987 18 6.5 18H7.5"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {!hide && <p className="text-base cursor-pointer">Sign Out</p>}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NavBar;
